const MODULE_NAME = 'TasksModule';

export const GET_CURRENT_TASK = `${MODULE_NAME}/GET_CURRENT_TASK`;
export const GET_TASKS = `${MODULE_NAME}/GET_TASKS`;
export const GET_CURRENT_FOLDER = `${MODULE_NAME}/GET_CURRENT_FOLDER`;
